/**
 * Maps a P `event_type` string to a stable i18n message key. Unknown types
 * fall back to the drilling label so the UI never shows a raw code.
 */
import type { EventOut } from "@api/types";
import type { MessageKey } from "@i18n/messages";

export type { EventOut };

export type MessageEventTypeKey = Extract<MessageKey, `eventType.${string}`>;

const MAP: Record<string, MessageEventTypeKey> = {
  drilling: "eventType.drilling",
  completion: "eventType.completion",
  workover: "eventType.workover",
  intervention: "eventType.intervention",
};

export function eventTypeKey(ev: EventOut): MessageEventTypeKey {
  return MAP[ev.event_type.toLowerCase()] ?? "eventType.drilling";
}

/**
 * Maps a raw job/event CODE (e.g. TPO/TFR/TPR) to a friendly i18n label key.
 * Demo mapping (a FE label map for now; a candidate for an Oxbo-M catalog later).
 * Unknown codes return null so the caller can fall back to showing the raw code.
 */
type JobCodeKey = Extract<MessageKey, `jobCode.${string}`>;

const JOB_CODE_MAP: Record<string, JobCodeKey> = {
  TPO: "jobCode.unconventionalCompletion",
  TFR: "jobCode.unconventionalCompletion",
  TPR: "jobCode.conventionalCompletion",
};

/** The friendly-label i18n key for a job code, or null when unmapped. */
export function jobCodeKey(code: string | null | undefined): JobCodeKey | null {
  if (!code) return null;
  return JOB_CODE_MAP[code.trim().toUpperCase()] ?? null;
}
